import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import helper, { _loadComponent } from '@/services/helper';
import store from '@/store';
import Swal from 'sweetalert2';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/start',
    name: 'Start',
    component: (resolve: any) => _loadComponent('Start/', resolve, true),
  },
  {
    path: '/vote/:subjectIndex',
    name: 'Vote',
    props: true,
    component: (resolve: any) => _loadComponent('Vote/', resolve, true),
  },
  {
    path: '/confirm/:subjectIndex',
    name: 'SubjectConfirm',
    props: true,
    component: (resolve: any) => _loadComponent('SubjectConfirm/', resolve, true),
  },
  {
    path: '/final',
    name: 'FinalConfirm',
    props: true,
    component: (resolve: any) => _loadComponent('FinalConfirm/', resolve, true),
  },
  {
    path: '/thankyou',
    name: 'ThankYou',
    props: true,
    component: (resolve: any) => _loadComponent('ThankYou/', resolve, true),
  },
  {
    path: '/accessibility-declaration',
    name: 'AccessibilityDeclarationPage',
    props: true,
    component: (resolve: any) => _loadComponent('AccessibilityDeclaration/', resolve, true),
    meta: {
      AllowAnonymous: true,
    },
  },
];
if (process.env.VUE_APP_MODE === 'WEB') {
  routes.push(
    ...[
      {
        path: '/',
        name: 'Login',
        component: (resolve: any) => _loadComponent('VoterLogin/', resolve, true),
        meta: {
          AllowAnonymous: true,
        },
      },
      {
        path: '/help',
        name: 'Help',
        component: (resolve: any) => _loadComponent('Help/', resolve, true),
        meta: {
          AllowAnonymous: true,
        },
      },
      {
        path: '/help/:tocken',
        name: 'HelpStatus',
        props: true,
        component: (resolve: any) => _loadComponent('HelpStatus/', resolve, true),
        meta: {
          AllowAnonymous: true,
        },
      },
    ],
  );
}

if (process.env.VUE_APP_MODE === 'SA' || process.env.VUE_APP_MODE === 'CS') {
  routes.push(
    ...[
      {
        path: '/',
        name: 'Login',
        component: (resolve: any) => _loadComponent('StationLogin/', resolve, true),
        meta: {
          AllowAnonymous: true,
        },
      },
    ],
  );
}

if (process.env.VUE_APP_MODE === 'SA') {
  routes.push(
    ...[
      {
        path: '/assign',
        name: 'VoterAssign',
        component: (resolve: any) => _loadComponent('VoterAssign/', resolve, true),
      },
    ],
  );
}

routes.push({ path: '*', redirect: '/' });

const router = new VueRouter({
  routes,
});
let isBack = false;
window.addEventListener('popstate', function(e) {
  var state = e.state;
  if (state !== null) {
    isBack = true;
  }
});

router.beforeEach(async (to, from, next) => {
  /**
   * close swal
   */
  if (Swal.isVisible() && !Swal.isLoading() && isBack) {
    Swal.close();
    next(false);
    isBack = false;
    return;
  }
  isBack = false;

  /**
   * close modal
   */
  if (to.name === from.name) {
    const keys = Object.keys(from.query).filter((key) => from.query[key] === 'y' && !to.query[key]);
    keys.forEach((key) => {
      Vue.prototype.$modal.hide(key);
    });
  } else {
    store.commit('Header', '');
  }

  /**
   * Auth guard
   */
  if (to.name != from.name && !to.meta.AllowAnonymous && !store.state.IsAuthenticated) {
    console.log('route guard');
    next({ path: '/' });
    return;
  }

  next();
});

export default router;
